import React from "react";

const Washing_13 = React.forwardRef(
  ({ width = "32", height = "28", viewBox = "0 0 32 28", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 0L0 28H32L16 0ZM16 4.14815L3.55556 25.9259H28.4444L16 4.14815Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_13;
